import isNil from 'lodash/isNil';
import cx from 'classnames';

import { Flex } from "@common/components/Flex";

import './tabs.styles.scss';

export const Tabs = (props) => {
	const { items, value: tabsValue, defaultValue, className, onChange } = props;
  const [currentTab, setCurrentTab] = React.useState(defaultValue || tabsValue);

  const handleChange = React.useCallback((e) => {
    e.persist();

    if (currentTab === e.currentTarget.value) {
      return;
    }

    setCurrentTab(e.currentTarget.value);

    if (onChange) {
      onChange(e.currentTarget.value);
    }
  }, [currentTab, onChange]);
  
	return (
		<Flex width="100%" justify="flex-start" alignItems="flex-center" className={cx("Tabs", className)}>
      {items.map(({ label, value, ...otherProps }) => (
        <button
          key={value || label}
          className={cx('Tabs__item', { 'Tabs__item--selected': (isNil(currentTab) || isNil(value)) ? false : currentTab === value })}
          value={value}
          onClick={handleChange}
          {...otherProps}
        >
          {label}
        </button>  
      ))}
    </Flex>
	);
};